import styled from "styled-components";
import { FaFilePen, FaTrash, FaEnvelope, FaPlus } from 'react-icons/fa6';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import execute from "hooks/execute";
import { protectedResources } from 'config/msalConfig';
import DeleteConfirmationModal from "components/shared/DeleteConfirmationModal";
import { Badge, Button, Space, Table, Input } from "antd";
import qs from 'qs';
import { DataEditor } from "./DataEditor";
// import OrgModuleData from "components/shared/OrganizationModules/OrgModuleData";
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import EditUserModal from "components/EditUserModel";
import ShareInvitationModal from "components/ShareInvitationModal";
import { App, message } from 'antd';
import RoleValueTable from "./RoleValueSubTable/RoleValueTable";

// import { NewOrganizationModal } from "./NewOrganizationModal";



function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');  // Adjust 'en-US' as needed for your locale
}

function UserManagementTable({ userDetails,custDomain,Modal, searchResults }) {    
    const [isDataEditorOpen, setIsDataEditorOpen] = useState(false);        
    const [editableDataItem, setEditableDataItem] = useState({});

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);


    const [modalIsOpen, setModalIsOpen] = useState(false);

    const toggleModal = () => {
        setIsDataEditorOpen(!isDataEditorOpen);
    };

    // const handleUserAdded = () => {
    //     setRefreshData(!refreshData); // Toggle refreshData to trigger data refetch
    //   };

    console.log("userDetails/////////////")
    console.log(userDetails)

    const [currentRecord, setCurrentRecord] = useState(null);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const { orgId } = useParams();
    const [customers, setCustomers] = useState(searchResults || []);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const [inviteInfo, setInviteInfo] = useState({ name: '', email: '', link: '' });
    const [invitedUserId, setInvitedUserId] = useState(null);

    const [tableParams, setTableParams] = useState({
        pagination: {
          current: 1,
          pageSize: 10,
        },
    });

    const toBoolean = (value) => value === true || value === 1 || value === '1';

    const openEditorToAdd = () => {
        console.log("openEditorToAdd");
        setEditableDataItem({Org_ID: orgId});
        setIsDataEditorOpen(true);
    };

    const openEditorToEdit = (record) => {
        console.log("edit", record);
        setEditableDataItem(record);
        setIsDataEditorOpen(true);
    };

    //searchFilter
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
            padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
                marginBottom: 8,
                display: 'block',
            }}
            />
            <Space>
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                width: 90,
                }}
            >
                Search
            </Button>
            <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                width: 90,
                }}
            >
                Reset
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({
                    closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
                }}
            >
                Filter
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                close();
                }}
            >
                close
            </Button>
            </Space>
        </div>
        ),
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
            color: filtered ? '#1677ff' : undefined,
            }}
        />
        ),
        onFilter: (value, record) =>
        record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
        onOpenChange(open) {
            if (open) {
            setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        },
        render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });

  //endSearchFilter

    const columns = [
        {
            title: 'Created On',
            dataIndex: 'CreatedOn',
            key: 'CreatedOn',
            sorter: true,
            render: (text) => formatDate(text),
        },
        {
            title: 'First Name',
            dataIndex: 'FirstName',
            key: 'FirstName',
            sorter: true,
            ...getColumnSearchProps('FirstName'),
        },
        {
            title: 'Last Name',
            dataIndex: 'LastName',
            key: 'LastName',
            sorter: true,
            ...getColumnSearchProps('LastName'),
        },
        {
            title: 'Email',
            dataIndex: 'Email',
            key: 'Email',
            sorter: true,
            ...getColumnSearchProps('Email'),

        },
        {
            title: 'Admin',
            dataIndex: 'Admin',
            key: 'Admin',
            sorter: true,
            // ...getColumnSearchProps('Admin'),
            render: (text, record) => (
                <p>{record.IsAdmin ? "Yes" : "No"}</p>
            )
        },
        {
            title: 'Status',
            dataIndex: 'IsActive',
            key: 'IsActive',
            sorter: true,
            // ...getColumnSearchProps('IsActive'),
            render: (text, record) => (
                <span
                className={`inline-block w-20 h-6 leading-6 text-white text-center rounded cursor-default ${
                  !toBoolean(record.IsActive)
                    ? 'bg-gray-500'
                    : (!toBoolean(record.IsB2COnboarded) ? 'bg-orange-500' : 'bg-green-500')
                }`}
              >
                {!toBoolean(record.IsActive)
                    ? 'Inactive'
                    : (!toBoolean(record.IsB2COnboarded) ? 'Pending Onboard' : 'Active')}
              </span>
            )
        },
        {
            title: <Button color="default" variant="text" onClick={ openEditorToAdd } icon={<FaPlus  style={{ color: '#ffad1c' }} />} />,
            key: 'actions',
            render: (text, record) => (
                <>
                    <Button  color="default" variant="text"  title="Resend the invitation" onClick={(e) => {
                        e.stopPropagation();
                        handleSendInvitation( record, record.UserID );
                    }} icon={<FaEnvelope style={{ color: '#ffad1c' }} />} />
                                            
                    <Button   color="default" variant="text" onClick={(e) => {
                        console.log(record)
                        e.stopPropagation(); // Prevent row click
                        // openEditorToEdit(record);
                        setCurrentRecord({ ...record, UserId: record.UserID });
                        setIsEditModalOpen(true);
                    }} icon={<FaFilePen  style={{ color: '#ffad1c' }} />} />
                                        
                    <Button   color="default" variant="text" onClick={(e) => {
                        e.stopPropagation(); // Prevent row click
                        handleDelete(record.UserID,record);
                    }} icon={<FaTrash style={{ color: '#ffad1c' }} />} />
                </>
                
            ),
        },
    ];

    const handleSaveEditedUser = async updatedRecord => {
        await fetchData(); // Refetch data after deletion
        setIsEditModalOpen(false);
      };

    const handleDataEditFinished = (newData) => {
        console.log("handleDataEditFinished", newData, editableDataItem);
        setIsDataEditorOpen(false);
        fetchData();
    };

    const handleDataEditCancelled = () => {
        console.log("handleDataEditCancelled");
        setIsDataEditorOpen(false);
    };


    const getTableParams = (params) => ({
        email: userDetails.Email,
        pS: params.pagination?.pageSize,
        pN: params.pagination?.current,
        sF: params.sortField,
        sO: params.sortOrder,
        f: params.filters
        // ...params,
    });
  const { message, model, notification } = App.useApp();


    const handleSendInvitation = async (record, userId) => {
        console.log('Send Invitation:', userId, record);
        try {
        var response = await execute('POST', `${protectedResources.api.baseEndPoint}/customerUsers/sendSignupInvitation`, {
          userId: userId,
          sendEmail: false
        });
        if(response.success){
          const data = response.data || {};
          setInviteInfo({
            name: data.customerName || `${record.FirstName || ''} ${record.LastName || ''}`.trim(),
            email: data.email || record.Email || '',
            link: data.inviteLink || ''
          });
          setInvitedUserId(userId);
          setInviteModalOpen(true);
        }else{
          message.error(response.message || 'Failed to send invitation');
        }
        }catch(error){
          message.error('Failed to send invitation: ' + error.message);
        }
    };

    const handleCopyInvite = async () => { try { await navigator.clipboard.writeText(inviteInfo.link || ''); } catch (_) {} };
    const handleResendEmail = async () => {
        const response = await execute('POST', `${protectedResources.api.baseEndPoint}/customerUsers/sendSignupInvitation`, { userId: invitedUserId, inviteLink: inviteInfo.link, sendEmail: true });
        if (!response.success) {
            throw new Error(response.message || 'Failed to send invitation');
        }
        return true;
    };

    const handleDelete = (userId, record) => {
        console.log(userId, record)
        setCurrentRecord({ ...record, UserId: userId });
        setDeleteModalOpen(true);
      };

    const handleConfirmDelete = async () => {
        console.log(currentRecord)
        // return;
        try {
            const response = await execute('DELETE', `${protectedResources.api.baseEndPoint}/customerUsers/${currentRecord.UserID}`);
            if (response.success) {
                alert('User deleted successfully.');
                await fetchData(); // Refetch data after deletion
            } else {
                setError(response.message || 'Failed to delete user');
            }
        } catch (error) {
            alert('Failed to delete user: ' + error.message);
        }
        setDeleteModalOpen(false);
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            console.log(getTableParams(tableParams))
            const response = await execute('GET', `${protectedResources.api.baseEndPoint}/customerUsers/fellowCustomerUsers?${qs.stringify(getTableParams(tableParams))}`);
            console.log(response)
            if (response.success && response.data.length > 0) {
                console.log("customerData///////////")
                console.log(response.data)
                setCustomers(response.data);
                setTableParams({
                    ...tableParams,
                    pagination: {
                      ...tableParams.pagination,
                      //total: 200,
                      // 200 is mock data, you should read it from server
                        total: response.totalRecords,
                    },
                  });
                setError('');
            } else {
                setCustomers([]);
                setError(response.message || 'No customers found for the specified organization');
            }
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch data: ' + err.message);
            setLoading(false);
        }
    };
    useEffect(() => {
        if(userDetails.Email){
            fetchData();
        }
    }, [orgId, 
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        // searchText
        tableParams?.filters,
    ]);

    useEffect(() => {
        fetchData();
    }, [orgId]);

    useEffect(() => {
        if (searchResults) {
            setCustomers(searchResults);
        }
    }, [searchResults]);

    const handleTableChange = (pagination, filters, sorter) => {
        console.log("filters change")
        console.log(filters)
        console.log('handleTableChange', pagination, filters, sorter);

        // Filter out null or empty values
        const cleanedFilters = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value && value.length > 0)
        );

        console.log(cleanedFilters)

        setTableParams({
          pagination,
          filters: cleanedFilters,
          sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
          sortField: Array.isArray(sorter) ? undefined : sorter.field,
        });
    
        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
          setCustomers([]);
        }
    };

    

    const handleCloseModalEdit = () => {
        setIsEditModalOpen(false);
      };

    const expandedRowRender = (record) => (
        <RoleValueTable customer={record} />
    );

    return (
        <>
            <Table
                columns={columns}
                rowKey={record => record.UserID}
                dataSource={customers}
                pagination={tableParams.pagination}
                loading={loading}
                expandable={{
                    expandedRowRender,
                    defaultExpandedRowKeys: ['0'],
                }}
                onChange={handleTableChange } />      
            
            {/* { isDataEditorOpen ? 
                <DataEditor 
                    isOpen={isDataEditorOpen} 
                    dataItem={editableDataItem} 
                    onDataEditorFinished={handleDataEditFinished} 
                    onDataEditorCancelled={handleDataEditCancelled} /> 
                    : null } */}
                
                <Modal
                    custDomain={custDomain}
                    isOpen={isDataEditorOpen}
                    onClose={toggleModal}
                    userEmail={userDetails.Email}
                    onUserAdded={fetchData} // Pass the onUserAdded prop to the modal
                />

                <EditUserModal custDomain={custDomain} isOpen={isEditModalOpen} onClose={handleCloseModalEdit} userData={currentRecord} onSave={handleSaveEditedUser}/>
                
            {isDeleteModalOpen && <DeleteConfirmationModal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)} record={currentRecord} onDeleteConfirmed={handleConfirmDelete} />}
            {inviteModalOpen && (
                <ShareInvitationModal
                    isOpen={inviteModalOpen}
                    name={inviteInfo.name}
                    email={inviteInfo.email}
                    inviteLink={inviteInfo.link}
                    onCopyLink={handleCopyInvite}
                    onSendEmail={handleResendEmail}
                    onClose={() => setInviteModalOpen(false)}
                />
            )}
        </>
    );
}




export default UserManagementTable;
